<!-- Invoice Log Modal -->
<div class="modal fade" id="invoiceLogModal" msEscClose
	(escPressed)="close()"
	data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
	aria-labelledby="invoiceLogModalLabel" aria-hidden="true">
	<div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
		<div class="modal-content invoice-log-modal-content">

			<div class="fs-5 border-0 p-4 pb-0">
				<div class="fw-semibold" id="invoiceLogModalLabel">Invoice #{{ chargeId() }} Log</div>
				@if (charge()?.propertyTitle) {
					<div class="text-muted">{{ charge()?.propertyTitle }}</div>
				}
			</div>

			<div class="modal-body p-4">
				@if (isOpen() && chargeId()) {
					<ms-audit-logs
						[entityId]="chargeId()!"
						[entityType]="AuditEntityType.PropertyCharge">
					</ms-audit-logs>
				}
			</div>

			<div class="modal-footer border-0 d-flex justify-content-center pb-4">
				<button type="button" class="btn btn-ms-secondary" (click)="close()">
					Close
				</button>
			</div>

		</div>
	</div>
</div>
